import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import api from '../api';
import { 
  FETCH_PATIENTS,
  FETCH_STARTED_PATIENTS,
  ON_SAVE_PATIENT,
  ON_DELETE_PATIENT,
  FILTER_PATIENTS,
  FETCH_MORE_PATIENTS
} from 'constants/ActionTypes';
import { fetchPatientsSuccess, showPatientsMessage, savePacientSuccess, showPatientsLoader, fetchStartedPatientsSuccess, deletePacientSuccess, fetchMorePatientsSuccess, showMorePatientsLoader } from 'actions/Patients';
import { userSignOut } from 'actions/Auth';

function* getPatients () {
  try {
    yield put(showPatientsLoader());
    const authToken = localStorage.getItem('token');
    const patients = yield call(api.patientsApi.getPatients, { authToken });

    if (patients.errorMessage) {
      yield put(showPatientsMessage(patients.errorMessage, true));
    } else {
      yield put(fetchPatientsSuccess(patients));
    }
  } catch (error) {
    yield put(showPatientsMessage(error.message || error, true));
    yield put(userSignOut());
  }
}

function* getStartedPatients() {
  try {
    yield put(showPatientsLoader());
    const authToken = localStorage.getItem('token');
    const pageSection = 'starred';
    const patients = yield call(api.patientsApi.getPatients, { authToken, pageSection });

    if (patients.errorMessage) {
      yield put(showPatientsMessage(patients.errorMessage, true));
    } else {
      yield put(fetchStartedPatientsSuccess(patients));
    }
  } catch (error) {
    yield put(showPatientsMessage(error.message || error, true));
    yield put(userSignOut());
  }
}

function* savePatient({ payload, isFavoriteRemoved }) {
  try {
    yield put(showPatientsLoader());
    const authToken = localStorage.getItem('token');

    let patients = {}
    if(!payload.id) {
      patients = yield call(api.patientsApi.savePatient, { payload, authToken });
    } else {
      patients = yield call(api.patientsApi.updatePatient, { payload, authToken });
    }
    patients.isFavoriteRemoved = isFavoriteRemoved

    if (patients.errorMessage) {
      yield put(showPatientsMessage(patients.errorMessage, true));
    } else {
      yield put(savePacientSuccess(patients));
    }
  } catch (error) {
    yield put(showPatientsMessage(error.message || error, true));
    yield put(userSignOut());
  }
}

function* deletePatient({ payload }) {
  try {
    yield put(showPatientsLoader());
    const authToken = localStorage.getItem('token');

    const patients = yield call(api.patientsApi.deletePatient, { payload, authToken });

    if (patients.errorMessage) {
      yield put(showPatientsMessage(patients.errorMessage, true));
    } else {
      yield put(deletePacientSuccess(payload));
    }
  } catch (error) {
    yield put(showPatientsMessage(error.message || error, true));
    yield put(userSignOut());
  }
}

function* searchPatient({ payload }) {
  try {
    const { searchName, pageSectionId } = payload;
    let pageSection = 'all';
    if (pageSectionId === 2) {
      pageSection = 'starred'
    };
    yield put(showPatientsLoader());
    const authToken = localStorage.getItem('token');

    const patients = yield call(api.patientsApi.getPatients, { authToken, pageSection, searchName });

    if (patients.errorMessage) {
      yield put(showPatientsMessage(patients.errorMessage, true));
    } else {
      if (pageSection === 'all') {
        yield put(fetchPatientsSuccess(patients));
      } else {
        yield put(fetchStartedPatientsSuccess(patients));
      }
    }
  } catch (error) {
    yield put(showPatientsMessage(error.message || error, true));
    yield put(userSignOut());
  }
}

function* getMorePatients({ payload }) {
  try {
    yield put(showMorePatientsLoader());
    const { searchName, pageSectionId, lastEvaluatedKey } = payload;
    let pageSection = 'all';
    if (pageSectionId === 2) {
      pageSection = 'starred'
    };
    // yield put(showPatientsLoader());
    const authToken = localStorage.getItem('token');

    const patients = yield call(api.patientsApi.getPatients, { authToken, pageSection, searchName, lastEvaluatedKey });

    if (patients.errorMessage) {
      yield put(showPatientsMessage(patients.errorMessage, true));
    } else {
      yield put(fetchMorePatientsSuccess(patients));
    }
  } catch (error) {
    yield put(showPatientsMessage(error.message || error, true));
    yield put(userSignOut());
  }
}

export function* fetchPatients() {
  yield takeEvery(FETCH_PATIENTS, getPatients);
}

export function* startedPatients() {
  yield takeEvery(FETCH_STARTED_PATIENTS, getStartedPatients);
}

export function* savePatients() {
  yield takeEvery(ON_SAVE_PATIENT, savePatient);
}

export function* deletePatients() {
  yield takeEvery(ON_DELETE_PATIENT, deletePatient);
}

export function* searchPatients() {
  yield takeEvery(FILTER_PATIENTS, searchPatient);
}

export function* fetchMorePatients() {
  yield takeEvery(FETCH_MORE_PATIENTS, getMorePatients);
}

export default function* rootSaga() {
  yield all([
    fork(fetchPatients),
    fork(startedPatients),
    fork(savePatients),
    fork(deletePatients),
    fork(searchPatients),
    fork(fetchMorePatients)
  ]);
}



// WEBPACK FOOTER //
// ./sagas/Patients.js